export const formatSchemaText = (input?: string | null): string | undefined => {
    if (!input) {
        return undefined;
    }

    const withoutBreaks = input.replace(/<\s*br\s*\/?\s*>/gi, '\n');
    const withParagraphBreaks = withoutBreaks.replace(/<\s*\/\s*p\s*>/gi, '\n\n').replace(/<\s*p[^>]*>/gi, '');
    const withoutTags = withParagraphBreaks.replace(/<[^>]+>/g, '');
    const withoutBullets = withoutTags
        .split('\n')
        .map(line => line.replace(/^\s*[\u2022\u25CF\u25E6\-\*]\s+/u, ''))
        .join('\n');
    const normalized = withoutBullets
        .replace(/[ \t\f\v]+/g, ' ')
        .replace(/\n{3,}/g, '\n\n')
        .trim();

    return normalized.length > 0 ? normalized : undefined;
};
